import ArrowLeftIcon from "~/assets/icons/ArrowLeftIcon"
import ArrowRightIcon from "~/assets/icons/ArrowRightIcon"
import { Group } from "~/types"

type Props = {
    nextOption: () => void,
    prevImage: () => void,
    currentIndex: number,
    currentGroupIndex: number,
    options: Group[],
    handleArrowClick: (direction: string) => void
}

const CarouselArrows = ({ nextOption, prevImage, currentIndex, currentGroupIndex, options, handleArrowClick }: Props) => {
    
    return (
        <div className="arrows">
            {currentIndex > 0 && (
                <div className="arrow-left" onClick={() => {
                    handleArrowClick('left');
                    prevImage();
                }}>
                    <ArrowLeftIcon color="#fff" />
                </div>
            )}
            {currentIndex < options[currentGroupIndex]?.Options.length - 1 && (
                <div className="arrow-right" onClick={() => {
                    handleArrowClick('right');
                    nextOption();
                }}>
                    <ArrowRightIcon color="#fff" />
                </div>
            )}
        </div>
    )
}

export default CarouselArrows;